import { useState } from 'react';
import qs from 'qs';
import searchTypes from '../data/searchTypeOptions';

const queryParams = qs.parse(window.location.search.slice(1));

const getSearchTypeById = index => searchTypes.find(option => option.index === index);
const getDefaultType = () => searchTypes.find(option => option.default);

const useSearchType = ({ isAttendeeSearch, isMemberCompanySearch, isPublicationsSearch, defaultSearchType }) => {
    const getDefault = () => {
        if (defaultSearchType) {
            return defaultSearchType;
        }

        if (isPublicationsSearch) {
            return searchTypes.find(option => option.index === 'everything');
        }

        if (isAttendeeSearch) {
            return searchTypes.find(option => option.index === 'member_events');
        }

        if (isMemberCompanySearch) {
            return searchTypes.find(option => option.index === 'members');
        }

        if (queryParams.type && getSearchTypeById(queryParams.type)) {
            return getSearchTypeById(queryParams.type);
        }

        return getDefaultType();
    };

    const [searchType, setSearchType] = useState(getDefault());

    return { searchType, setSearchType };
};

export default useSearchType;
